import * as React from 'react';

import RenderFormList, { IFormListProps } from '../../../../Components/FormList';


/**
 * Forwards render
 */
const FormList: React.FunctionComponent<IFormListProps> = (props) => {
    return (
        <RenderFormList {...props}/>
    );
};

FormList.displayName = 'FormList';

export default FormList;
